import React from 'react'
import Title from '../components/dashContent/Title'
import { Outlet } from 'react-router-dom';

const Works = () => {
  return (
    <div className='m-1'>
        <Title text="Trabalhos"/>
        <Outlet>
        
      </Outlet>
    </div>
  )
}

export default Works